export class BotNotificationDataDTO {
    Id!: string;
    Type!: string;
}